module.exports = __webpack_public_path__ + "media/application-logos/buildout-connect-stacked-navy-efac7849.svg";